<footer>
  <div *ngIf="authoringContentData" class="container " id="footer">
    <div class="application-footer">
      <div class="logo-wrapper">
        <img  src="/assets/tfb-acctmgmt/images/TMO-Business.svg" alt="{{authoringContentData?.footer?.tmobileIncTxt}}">
      </div>
      <div class="footer-link" id="inctext">
        <div class="row">
          <div class="col-md-12 col-xs-12">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-4 mb-3">
                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="12"
                  href="{{authoringContentData?.footer?.termsAndConditionUrl}}" rel="noopener" >{{authoringContentData?.footer?.termsConditionTxt}}</a>

                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="13"
                  href="{{authoringContentData?.footer?.termsOfUseUrl}}" rel="noopener">{{authoringContentData?.footer?.termsOfUseTxt}}</a>

                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="14"
                  href="{{authoringContentData?.footer?.privacyPolicyUrl}}" rel="noopener">{{authoringContentData?.footer?.privacyPolicyTxt}}</a>

                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="15"
                  href="{{authoringContentData?.footer?.returnPolicyUrl}}" rel="noopener">{{authoringContentData?.footer?.returnPolicyTxt}}</a>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-4 mb-3">
                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="16"
                  href="{{authoringContentData?.footer?.openInternetUrl}}" rel="noopener">{{authoringContentData?.footer?.openInternetTxt}}</a>

                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="17"
                  href="{{authoringContentData?.footer?.consumerUrl}}" rel="noopener">{{authoringContentData?.footer?.consumerInfoTxt}}</a>

                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="18"
                  href="{{authoringContentData?.footer?.publicSafetyUrl}}" rel="noopener">{{authoringContentData?.footer?.publicSafetyTxt}}</a>

                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="19"
                  href="{{authoringContentData?.footer?.accessibilityUrl}}" rel="noopener">{{authoringContentData?.footer?.accessibilityTxt}}</a>
              </div>

              <div class="col-xs-12 col-sm-6 col-md-4 mb-3">
                <a (click)="onDNSNavigate();" class="gray-link mb-3 Ontab-focus" tabIndex="20"
                  href="javascript:void(0)">{{authoringContentData?.footer?.doNotSellMyPersonalInfoTxt}}</a>

                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="21"
                  href="{{authoringContentData?.footer?.privacyCenterUrl}}" rel="noopener">{{authoringContentData?.footer?.privacyCenterTxt}}</a>

                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="22"
                  href="{{authoringContentData?.footer?.coverageUrl}}" rel="noopener">{{authoringContentData?.footer?.coverageTxt}}</a>

                <a class="gray-link mb-3 Ontab-focus" target="_blank" tabIndex="23"
                  href="{{authoringContentData?.footer?.supportUrl}}" rel="noopener">{{authoringContentData?.footer?.supportTxt}}</a>
              </div>

            </div>
          </div>
        </div>
        <div class="social-media">
          <ul class="social_links">
            <li>
              <a href="{{authoringContentData?.footer?.linkedInUrl}}" target="_blank" rel="noopener"  class="Linkedin Ontab-focus" tabIndex="24">
                <img  class="socialSite" src="/assets/tfb-acctmgmt/images/linkedinicon.svg"
                  alt="{{authoringContentData?.footer?.linkedInUrl}}">
              </a>
            </li>
            <li>
              <a href="{{authoringContentData?.footer?.facebookUrl}}" target="_blank" rel="noopener"  class="Ontab-focus" tabIndex="25">
                <img  class="socialSite" src="/assets/tfb-acctmgmt/images/facebookicon.svg"
                  alt="{{authoringContentData?.footer?.facebookUrl}}">
              </a>
            </li>
            <li>
              <a href="{{authoringContentData?.footer?.twitterUrl}}" target="_blank" rel="noopener"  class="Ontab-focus" tabIndex="26">
                <img  class="socialSite" src="/assets/tfb-acctmgmt/images/twittericon.svg"
                  alt="{{authoringContentData?.footer?.twitterUrl}}">
              </a>
            </li>
          </ul>
          <span class="small-text ">{{authoringContentData?.footer?.tmobileIncTxt}}</span>
        </div>
      </div>
    </div>
  </div>
</footer>
